import React from 'react'
import Detay from './Detay'

const JuniorDetay = () => {
  return (
    <div>
        <Detay page="juniorDetay"/>
    </div>
  )
}

export default JuniorDetay